import React from "react";
import "./Phonetics.css";

export default function Phonetics(props) {
  //console.log(props.phonetic);
  return (
    <div className="phonetic">
      <a href={props.phonetic.audio} target="_blank" rel="noreferrer">
        Listen
      </a>
      <span className="phoText">{props.phonetic.text}</span>
    </div>
  );
}
